import { Chip, SxProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PaymentStatus } from "src/business/payment/payment";
import {
  colorBorderError,
  colorBorderSuccess,
  colorBorderWarning,
  colorChipBackground,
  colorChipBorder,
  colorSurfaceError,
  colorSurfaceSuccess,
  colorSurfaceWarning,
  colorTextError,
  colorTextMuted,
  colorTextSuccess,
  colorTextWarning,
  radiusChip,
} from "src/design/tokens";

const STATUS_STYLES: Record<
  PaymentStatus,
  { bg: string; color: string; border: string }
> = {
  PENDING: {
    bg: colorSurfaceWarning,
    color: colorTextWarning,
    border: colorBorderWarning,
  },
  CONFIRMED: {
    bg: colorSurfaceSuccess,
    color: colorTextSuccess,
    border: colorBorderSuccess,
  },
  REJECTED: {
    bg: colorSurfaceError,
    color: colorTextError,
    border: colorBorderError,
  },
  CANCELLED: {
    bg: colorChipBackground,
    color: colorTextMuted,
    border: colorChipBorder,
  },
};

interface PaymentStatusChipProps {
  status: PaymentStatus;
  sx?: SxProps;
}

/** A payment's status, shared by the restaurateur's history and the ops queue. */
export const PaymentStatusChip = ({ status, sx }: PaymentStatusChipProps) => {
  const { t } = useTranslation();
  const { bg, color, border } = STATUS_STYLES[status];

  return (
    <Chip
      size="small"
      label={t(`payments.status.${status}`)}
      sx={{
        backgroundColor: bg,
        color,
        border: `1px solid ${border}`,
        borderRadius: radiusChip,
        fontWeight: 600,
        fontSize: 11,
        ...sx,
      }}
    />
  );
};
